module.exports = __webpack_public_path__ + "static/media/planos_vita_new.9e4abd08.png";